import Box from '@mui/material/Box'
import LinearProgress from '@mui/material/LinearProgress'

interface ApiLoadingProps {
  marginTop?: number
}
export const ApiLoading: React.FC<ApiLoadingProps> = ({ marginTop }) => {
  if (marginTop === undefined) {
    marginTop = 8
  }
  return (
    <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, marginTop }}>
      <LinearProgress />
    </Box>
  )
}
